import * as React from 'react';
import {IProduct, IQuantity, IUser} from "../../functions/Interfaces";
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import AddressForm from "./AddressForm";
import PaymentForm from "./PaymentForm";
import Review from "./Review";
import {Helmet} from "react-helmet";
import { makeBridgeStringBool, makeBridgeStringObjectArray, getPurchaseCompletedString} from '../../functions/WebbridgeFunctions';

const steps = ["Shipping address", "Payment details", "Review your order"];

function getStepContent(
  step: number,
  products: IProduct[],
  quantity: IQuantity[],
  customer: IUser
) {
  switch (step) {
    case 0:
      return <AddressForm customer={customer} />;
    case 1:
      return <PaymentForm />;
    case 2:
      return <Review products={products} quantity={quantity} />;
    default:
      throw new Error("Unknown step");
  }
}

class Checkout extends React.Component<any,{activeStep: number; productsBasket: IProduct[];basketQuantity: IQuantity[];}> {
  public mounted : boolean = false;
  constructor(props: any) {
    super(props);

    this.state = {
      activeStep: 0,
      productsBasket: [],
      basketQuantity: []
    };
  }

  public componentDidMount() {
    this.mounted = true;
  }

  public componentWillUnmount(){
    this.mounted = false;
  }

  public handleNext = () => {
    if (this.mounted) {
      this.setState(state => ({
        activeStep: state.activeStep + 1
      }));
    }
  };

  public handleBack = () => {
    if (this.mounted) {
      this.setState(state => ({
        activeStep: state.activeStep - 1
      }));
    }
  };

  public handleReset = () => {
    if (this.mounted) {
      this.setState({
        activeStep: 0
      });
    }
  };

  public setBasketData = () => {
    if (this.mounted) {
      this.setState({
        productsBasket: this.props.products,
        basketQuantity: this.props.quantity
      });
    }
  };

  public render() {
    const activeStep: number = this.state.activeStep;
    const linkBasket : string = process.env.PUBLIC_URL + "/basket";

    if(this.props.products.length === 0 && this.state.activeStep !== steps.length) {
      location.replace(linkBasket);
      location.reload;
    }


    return (
      <div className="CheckoutAll">
        <Stepper activeStep={activeStep} className="Stepper">
          {steps.map(label => (
            <Step key={label}>
              <StepLabel>{label}</StepLabel>
            </Step>
          ))}
        </Stepper>
        <div>
          {activeStep === steps.length ? (
            <div>
              {setHeaderPurchase(
                this.state.productsBasket,
                this.state.basketQuantity
              )}
              <Typography variant="h5" gutterBottom={true}>
                Thank you for your order.
              </Typography>
              <Typography variant="subtitle1">
                Your order number is #2001539. We have emailed your order
                confirmation, and will send you an update when your order has
                shipped.
              </Typography>
            </div>
          ) : (
            <React.Fragment>
              {getStepContent(
                activeStep,
                this.props.products,
                this.props.quantity,
                this.props.customer
              )}
              <div className="Buttons">
                {activeStep !== 0 && (
                  <Button onClick={this.handleBack} className="Buttons">
                    Back
                  </Button>
                )}
                {activeStep === steps.length - 1 ? (
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={() => {
                      this.props.actionClear();
                      this.handleNext();
                    }}
                    className="Buttons"
                  >
                    Place order
                  </Button>
                ) : (
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={() => {
                      this.handleNext();
                      this.setBasketData();
                    }}
                    className="Buttons"
                  >
                    Next
                  </Button>
                )}
              </div>
            </React.Fragment>
          )}
        </div>
      </div>
    );
  }
}
export default Checkout;

function setHeaderPurchase(products: IProduct[], quantity: IQuantity[]) {
  const bridgepurchase: string = makeBridgeStringBool("purchase", "true");

  const purchaseCompleted: string[] = getPurchaseCompletedString(
    products,
    quantity
  );
  const bridgeCompleted: string = makeBridgeStringObjectArray(
    "purchaseCompleted",
    purchaseCompleted
  );

  return (
    <Helmet>
      <script>{bridgepurchase}</script>
      <script>{bridgeCompleted}</script>
    </Helmet>
  );
} 


// WEBPACK FOOTER //
// ./src/components/checkout/Checkout.tsx